export default __webpack_public_path__ + "static/media/ripple.1fe5e955.svg";